import { Optional, Pipe, PipeTransform } from '@angular/core';
import { DateFormat } from '../../auth/models/mmu-user-preferences';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import moment from 'moment';

@Pipe({
  name: 'formatDate'
})
export class MmuFormatDatePipe implements PipeTransform {
  private readonly preferredFormat: DateFormat;

  constructor(@Optional() private userService?: MmuUserService) {
    this.preferredFormat = this.userService?.user?.prefs?.dateFormat ?? DateFormat.DD_MM_YYYY_SLASH;
  }

  transform(value: Date | string | number, format?: DateFormat): string | null {
    if (!value) {
      return null;
    }

    format = format ?? this.preferredFormat;

    /* Replace the format string with a valid moment.js format string. In moment.js, an uppercase D is used for the date placeholder while
    * the DateFormat Enum uses a lowercase letter. It cannot be changed in the Enum because these values are already used in production. */
    const dateFormat = format.replace(/d/g, 'D');

    const date = moment(new Date(value));
    return date.isValid() ? date.format(dateFormat) : null;
  }
}
